import styled from 'styled-components';

export const CmsTileGridBlockHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CmsTileGridBlockInputHolder = styled.div`
  margin-bottom: 16px;
  max-width: 100%;
  width: 425px;
  height: 45px;
`;

export const CmsTileGridBlockTabSwitcherHolder = styled.div`
  margin-bottom: 16px;
`;
